import CozyCommand from './CozyCommand'
import CozyPrice from './CozyPrice'
import CozyYoutube from './CozyYoutube'
import CozyDate from './CozyDate'
import CozyItem from './CozyItem'
import CozyTooltip from './CozyTooltip'

const components = [
  CozyCommand,
  CozyPrice,
  CozyYoutube,
  CozyDate,
  CozyItem,
  CozyTooltip
]

const registerComponent = (component) => {
  const name = `cozy-${component.is}`
  if (!customElements.get(name))
    customElements.define(name, component)
}

export default () => {
  components.forEach(registerComponent)
  return components
}
